import { useState, useMemo, useRef, useEffect } from "react";
import { no_propagate, fuzzy_word_search } from "./utils";

const MenuSearch = ({ people, trips, set_selected_person, set_selected_trip, close_search, active }) => {

  const [search_text, set_search_text] = useState("");
  const input_ref = useRef(null);

  // Focus the input whenever this panel becomes active.
  useEffect(() => {
    if (active) input_ref.current.focus();
  }, [active]);

  // Tagged, alphabetically-sorted list of every person and trip name
  const search_items = useMemo(() => {
    const person_items = Object.values(people).map((person) => ({
      name: person.name,
      type: "person",
      index: person.person_index
    }));
    const trip_items = Object.values(trips).map((trip) => ({
      name: trip.trip_key_memory,
      type: "trip",
      index: trip.trip_index
    }));
    return [...person_items, ...trip_items].sort((a, b) => a.name.localeCompare(b.name));
  }, [people, trips]);

  const filtered_search_items = useMemo(() => {
    if (search_text.trim() === "") return search_items;
    return search_items
      .map(item => {
        const total_score = fuzzy_word_search(item.name.toLowerCase(), search_text);
        return total_score === null ? null : { ...item, total_score };
      })
      .filter(Boolean) // Remove null entries (no match)
      .sort((a, b) => b.total_score - a.total_score);
  }, [search_items, search_text]);

  const select_item = (item) => {
    close_search();
    if (item.type === "person") {
      set_selected_person(item.index);
    } else {
      set_selected_trip(item.index);
    }
  };

  const on_search_key_down = (e) => {
    if (e.key === "Enter" && filtered_search_items.length > 0) {
      select_item(filtered_search_items[0]);
    }
  };

  return (
    <div className={"menu_panel" + (active ? "" : " menu_panel_hidden")}>
      <input type="text" className="menu_input search_input" placeholder="Search" ref={input_ref}
             value={search_text} onChange={(e) => set_search_text(e.target.value)}
             onKeyDown={on_search_key_down} />
      <ul className="search_list">
        {filtered_search_items.map((item, i) => <li key={i} onClick={no_propagate(() => select_item(item))}>{item.name}</li>)}
      </ul>
    </div>
  );
};

export default MenuSearch;
